import { render } from "./Statuses.vue?vue&type=template&id=cc40f4b2&scoped=true"
import script from "./Statuses.vue?vue&type=script&lang=js"
export * from "./Statuses.vue?vue&type=script&lang=js"

import "./Statuses.vue?vue&type=style&index=0&id=cc40f4b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc40f4b2"]])

export default __exports__